import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Container, Current, Name, StyledIcon } from './styled';
import { IconName } from '../../../../../Icons';
export const Setting = ({ name, currentValue, onClick, className, styles, }) => {
    var _a;
    const { theme } = useTheme();
    const diffIds = {
        Audio: 'audio',
    };
    const settingType = (_a = diffIds[name]) !== null && _a !== void 0 ? _a : name.toLocaleLowerCase();
    return (React.createElement(Container, { style: styles.container, "data-test": "Setting", className: `Setting ${className}`, onClick },
        React.createElement(Name, { style: Object.assign(Object.assign({}, getFont(theme, 'h5')), styles.title), testID: `open_${settingType}_languages_settings_button`, "data-test": "Setting-Name", className: "Setting-Name", theme: theme }, name),
        React.createElement(Current, { style: Object.assign(Object.assign({}, getFont(theme, 'h5')), styles.currentContainer), className: "Setting-Current-Container", theme: theme, testID: `current_${settingType}` },
            React.createElement("span", { style: styles.currentTitle, "data-test": "Setting-Current-Name", className: "Setting-Current-Name" }, currentValue),
            React.createElement(StyledIcon, { style: styles.seeMoreIcon, className: "Setting-Current-Icon", name: IconName.subpage, color: "white" }))));
};
Setting.defaultProps = {
    className: '',
    styles: {
        container: null,
        title: null,
        currentContainer: null,
        currentTitle: null,
        seeMoreIcon: null,
    },
};
//# sourceMappingURL=index.js.map